import { useV2ListReleaseFlagsQuery } from "@generated";
import { ReleaseFlag, ReleaseFlagStatus } from "../../types";

interface ListReleaseFlagsResult {
  releaseFlags: ReleaseFlag[];
  isLoading: boolean;
  error: unknown;
  refetch: () => void;
}

const useListReleaseFlags = (): ListReleaseFlagsResult => {
  const { data, isLoading, error, refetch } = useV2ListReleaseFlagsQuery(
    {
      sort: ["-general-availability-date", "-beta-release-date"],
    },
    { refetchOnMountOrArgChange: true }
  );

  const releaseFlags: ReleaseFlag[] = (data?.data || []).map((row) => ({
    id: row.id ?? "",
    name: row.attributes.name,
    key: row.attributes.key,
    description: row.attributes.description ?? "",
    status: (row.attributes.status ?? "building") as ReleaseFlagStatus,
    betaReleaseDate: row.attributes["beta-release-date"] ?? "",
    generalAvailabilityDate: row.attributes["general-availability-date"] ?? "",
  }));

  return { releaseFlags, isLoading, error, refetch };
};

export default useListReleaseFlags;
